export default __webpack_public_path__ + "static/media/admin-login-bg.bdbd5fc8.png";